export default __webpack_public_path__ + "static/media/downArrow.310b249c.svg";